import { Box, Typography } from '@mui/material';
import * as React from 'react';
import { FunctionComponent } from 'react';
import IndustrialDisplay from './IndustrialDisplay';
import { LayoutStyles } from '../automotivePage/AutomotiveOverviewPage';
import ResponsiveSplitSection from '../common/ResponsiveSplitSection';
import { buttonProps } from '../investorPage/OverviewPage';
import { getLinkTextFromPimcore, getLinkURLFromPimcore } from '../../utils/Pimcore';
import type { ApplicationsContent } from '../../graphql/pimcore/modules/siteContent/types/ApplicationsContent';

interface IndustrialOverviewPageProps {
    contentTree: ApplicationsContent;
}
const IndustrialOverviewPage: FunctionComponent<IndustrialOverviewPageProps> = ({
    contentTree,
}) => {
    const dynamicLeftText = (
        <>
            <Typography
                sx={{
                    fontFamily: 'Poppins',
                    fontSize: '20px',
                    fontWeight: 600,
                    lineHeight: '30px',
                    textAlign: 'left',
                }}
            >
                {contentTree.Industrial.oilAndGas.title.content}
            </Typography>
            <Box
                sx={{
                    fontFamily: 'Poppins',
                    fontSize: '16px',
                    fontWeight: 400,
                    lineHeight: '24px',
                    textAlign: 'left',
                }}
                dangerouslySetInnerHTML={{
                    __html: contentTree.Industrial.oilAndGas.mainText.sanitizedContent,
                }}
            />
        </>
    );

    return (
        <>
            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    padding: '0',
                    width: '100%',
                    boxSizing: 'border-box',
                    flexDirection: 'column',
                    overflowY: 'hidden',
                    backgroundColor: '#F2F2F2',
                }}
            >
                <Box sx={LayoutStyles}>
                    <Typography sx={{ fontFamily: 'Poppins', fontSize: '24px', fontWeight: 700 }}>
                        {contentTree.Industrial.overviewTitle.content}
                    </Typography>
                    <Box
                        sx={{
                            fontFamily: 'Poppins',
                            fontSize: '16px',
                            fontWeight: 400,
                            lineHeight: '24px',
                            marginTop: '1.5rem',
                            marginBottom: '2rem',
                        }}
                        dangerouslySetInnerHTML={{
                            __html: contentTree.Industrial.overviewMainText.sanitizedContent,
                        }}
                    />
                </Box>
            </Box>
            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    padding: '0',
                    width: '100%',
                    boxSizing: 'border-box',
                    flexDirection: 'column',
                    overflowY: 'hidden',
                    backgroundColor: 'white',
                }}
            >
                <Box sx={{ ...LayoutStyles, marginBottom: '2rem' }}>
                    <IndustrialDisplay contentTree={contentTree} />
                </Box>
            </Box>
            <ResponsiveSplitSection
                textContent={dynamicLeftText}
                backgroundColor="#F2F2F2"
                smallScreenTextFirst={false}
                imageSrc={contentTree.Industrial.oilAndGas.mainImage.imageUrl}
                buttonText={getLinkTextFromPimcore(
                    contentTree.Industrial.oilAndGas.links.links[0],
                    'Products'
                )}
                buttonHref={getLinkURLFromPimcore(
                    contentTree.Industrial.oilAndGas.links.links[0],
                    '/browse/products/'
                )}
                buttonSx={buttonProps}
                bigScreenAlignItem={'center'}
            />
            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    padding: '0',
                    width: '100%',
                    boxSizing: 'border-box',
                    flexDirection: 'column',
                    overflowY: 'hidden',
                    backgroundColor: 'white',
                }}
            ></Box>
            <Box sx={{ backgroundColor: 'white', height: '10px' }}></Box>
        </>
    );
};

export default IndustrialOverviewPage;
